<template>
  <div class="passwordBox animated fadeInDown">
    <div class="row">
      <div class="col-md-12">
        <div class="ibox-content">
          <h1 class="font-bold text-center">Forgot password</h1>
          <p style="padding-top:30px;">Enter email address. We'll email a link for you to reset your password.</p>
          <div class="row">
            <div class="col-lg-12">
              <form class="m-t" role="form" id="baseInfo">
                <div class="form-group">
                  <el-input
                    v-model="email"
                    type="email"
                  />
                </div>
                <div class="text-center">
                  <el-button
                    type="primary"
                    @click="send"
                  >Send</el-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
import config from "../config";
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      email: ""
    };
  },
  mounted: function() {},
  methods: {
    async send(e) {
      var objdata = {};
      objdata.email = this.email;
      objdata.apiUrl = this.apiConfig.accountForgetPwd;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.$router.go(-1);
    }
  }
};
</script>
